import { useEffect } from 'react'

const DEVICE_WIDTH = 'width=device-width, initial-scale=1.0, viewport-fit=cover'

/**
 * Real phone width while the page is shown, whatever main.tsx forced on the
 * dashboard (1280 px after "Continue in the browser"). The previous value comes
 * back when the page goes away.
 */
export function useDeviceWidth(): void {
  useEffect(() => {
    const meta = document.querySelector('meta[name="viewport"]')
    if (!meta) return
    const previous = meta.getAttribute('content')
    meta.setAttribute('content', DEVICE_WIDTH)
    return () => {
      if (previous) meta.setAttribute('content', previous)
    }
  }, [])
}
